// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".report-channel-order-table .border-right{border-color:#d8d8d8}.report-channel-order-table .v-data-table__wrapper{border:1px solid #d8d8d8!important;border-radius:6px!important;box-shadow:0 2px 2px 0 rgba(0,0,0,.04)!important}.report-channel-order-table table thead tr td{font-size:13px!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
